import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DialogService } from '../shared/service/dialog.service';
import { FdFieldConfigs } from '../shared/fd-form-components/fd-form-components.module';
import { MccService } from './services/mcc.service';
import { MccPhysicalPersonDeleteModel, MccPhysicalPersonModel, SearchMccPhysicalModel } from './models/mcc-physical-person.model';
import { finalize, filter } from 'rxjs/operators';
import { LoadingService } from '../shared/service/loading.service';
import { Messages } from '../shared/messages/messages';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from '../shared/service/error.service';
import { AuthService } from '../shared/service/auth.service';
import { AdminRolesEnum } from '../shared/enums/admin-roles.enum';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { AddMccComponent } from './components/add-mcc/add-mcc.component';
import { HistoryMccComponent } from './components/history-mcc/history-mcc.component';


@Component({
    selector: 'app-mcc-physical-person',
    templateUrl: './mcc-physical-person.component.html',
    styleUrls: ['./mcc-physical-person.component.scss'],
    standalone: false
})
export class MccPhysicalPersonComponent implements OnInit {

  constructor(private formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private errorService: ErrorService,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private authService: AuthService,
    private mccPhysicalService: MccService
  ) { }

  dataSource = new MatTableDataSource<MccPhysicalPersonModel>();
  originalDataSource =  new MatTableDataSource<MccPhysicalPersonModel>();
  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  pageNumber = 0;
  size = 10;
  totalItens;
  itemsNotFoundByFilter = false;
  filterValues: SearchMccPhysicalModel = new SearchMccPhysicalModel();
  selectedInstitution: string;
  icons: { [key:string]: IconDefinition }


  ngOnInit(): void {
        this.startForms();
  }

  
  changePage(event: any) {
    this.size = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.search();
  }

  addMcc() {
    const dialogRef = this.dialog.open(AddMccComponent, {
      width: '60%',
      height: '85%',
      data: {
      }
    });

    dialogRef.afterClosed().subscribe(params => {
      if (params && params.institution && params.serviceContract) {
        this.search(params.institution, params.serviceContract);
      } else {
        this.search();
      }
    });
  }

  startForms(): void {

    this.formGroup = this.formBuilder.group({
      institution: ['', Validators.required],
      serviceContract: ['', Validators.required],
      mccFilter: [''],
    });

    this.fields = {
      institution: {
        label: 'Nº Instituição',
        controlName: 'institution',
        maskCharsReplace: /[. / -]/g,
        messages: {
          required: 'Informe uma instituição',
          invalid: 'Usuário inválido'
        }
      },
      serviceContract: {
        label: 'Service Contract',
        controlName: 'serviceContract',
        maskCharsReplace: /[. / -]/g,
        messages: {
          required: 'Informe um service contract',
          invalid: 'Usuário inválido'
        }
      },
      mccFilter: {
        label: 'Digite um MCC',
        controlName: 'mccFilter'
      },
    };
  }

  deleteMcc(item: MccPhysicalPersonDeleteModel) {
      if (!item) {
        return;
      }

      this.loadingService.show();
      this.mccPhysicalService.deleteMcc(item)
        .pipe(finalize(() => this.loadingService.hide()))
        .subscribe(response => {
          this.dialogService.openDialog(Messages.EDIT_SAVE_SUCCESS, () => this.search());
        }, (err: HttpErrorResponse) => this.errorService.handleXHRError(err, Messages.EDIT_SAVE_ERROR));  
  }
  
  itemDetails(item: MccPhysicalPersonModel) {
    const dialogRef = this.dialog.open(HistoryMccComponent, {
      width: '40%',
      height: '85%',
      data: {
        institution: this.formControls.institution.value,
        activities: item
      }
    });
  }

  search(institution?: string, serviceContract?: number) {
    this.filterValues.mcc = this.formControls.mccFilter.value;
    this.filterValues.institution = institution || this.formControls.institution.value;
    this.filterValues.serviceContract = serviceContract || this.formControls.serviceContract.value;

    const hasMcc = !!this.filterValues.mcc;
    const hasInstitution = !!this.filterValues.institution;
    const hasServiceContract = !!this.filterValues.serviceContract;

    if (
      (hasInstitution && hasServiceContract && !hasMcc) ||
      (hasInstitution && hasServiceContract && hasMcc)
    ) {
      this.getMccPhysicalPersonByFilter(this.filterValues);
    } else {
      return;
    }
 }
  
  getMccPhysicalPersonByFilter(filterValues: SearchMccPhysicalModel){
    this.getByFilters(filterValues);
  }

  getByFilters(filterValues: SearchMccPhysicalModel){
      this.loadingService.show();
    this.mccPhysicalService.getPhysicalPersonsMccs(filterValues)
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(pageable => {
        this.dataSource.data = pageable.response;
        this.formControls.mccFilter.setValue('');
        this.originalDataSource.data = this.cloneArray(this.dataSource.data);
        this.totalItens = pageable.totalItens;
        this.pageNumber = pageable.page;
        this.size = pageable.size;
      });
  }

  changeSelectedInstitution(institution: string) {
    this.selectedInstitution = institution;
  }

  cloneArray(arr: any[]) {
    return JSON.parse(JSON.stringify(arr));
  }

  get hasInstitutionAndServiceContract() {
    return this.formControls && this.formControls.serviceContract && this.formControls.serviceContract.value;
  }

  
  get formControls() {
    return this.formGroup.controls;
  }

  get hasValue() {
    return !!(this.dataSource && this.dataSource.data && this.dataSource.data.length);
  }

  get hasWriteAccess() {
    return this.authService.isUserInRoles([AdminRolesEnum.MCC_PHYSICAL_PERSON_WRITE]);
  }

}
